// Client-supplied standard times. Checkout intentionally follows the supplied 11pm.
export const stayTimes = { checkIn: '2pm', checkOut: '11pm' };

// Weekend nights are configurable: Sunday = 0 through Saturday = 6.
export const weekendNights = [5, 6];
